const resize = async (url, maxSize, quality) => {
  const res = await fetch(url);
  const blob = await res.blob();
  const bitmap = await createImageBitmap(blob);

  const scale = Math.min(maxSize / bitmap.width, maxSize / bitmap.height, 1);
  const canvas = document.createElement('canvas');
  canvas.width = Math.round(bitmap.width * scale);
  canvas.height = Math.round(bitmap.height * scale);

  const ctx = canvas.getContext('2d');
  ctx.drawImage(bitmap, 0, 0, canvas.width, canvas.height);
  bitmap.close();

  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (thumbBlob) => {
        if (!thumbBlob) {
          return reject(console.error('image blob failed'));
        }
        return resolve(URL.createObjectURL(thumbBlob));
      },
      'image/webp',
      quality
    );
  });
};

// eslint-disable-next-line import/prefer-default-export
export const getThumbnail = (url, { maxSize = 500, quality = 0.8 } = {}) => {
  if (!url) {
    return Promise.resolve(null);
  }

  const promise = resize(url, maxSize, quality).catch((err) => {
    console.error(err);
  });

  return promise;
};
